export var LegalTermsUsedIn = /*#__PURE__*/ function(LegalTermsUsedIn) {
    LegalTermsUsedIn["Draft"] = "draft";
    LegalTermsUsedIn["ProposalTemplate"] = "proposalTemplate";
    return LegalTermsUsedIn;
}({});
 // eslint-disable-line @typescript-eslint/no-explicit-any
